<template>
  <div class="wrap">
    <div class="bkn">
      <span class="lb-ico">
        <img src="https://static.xfanread.com/readingDay2020/quickspot/jy@2x.png" />
      </span>
      <span class="topic-text"></span>
    </div>
    <div class="time-box">
      <i></i>
      <span id="sec">{{ usetime }}</span>
    </div>
    <div class="img-group">
      <div class="img-box mb-24">
        <img id="one" src="https://static.xfanread.com/readingDay2020/quickspot/csdhl1@2x.png" @click="handleClickOne" />


        <div class="progress-wrap">
          <div class="pie-right">
            <div class="right" ref="progressRight"></div>
          </div>
          <div class="pie-left">
            <div class="left" ref="progressLeft"></div>
          </div>
          <div class="mask"></div>
        </div>
        <!-- <div class="circle">
          <div class="pie-right">
            <div class="right" ref="progressRight"></div>
          </div>
          <div class="pie-left">
            <div class="left" ref="progressLeft"></div>
          </div>
          <div class="mask"><span>0</span>%</div>
        </div> -->
        <!-- <div class="circleProgress_wrapper">
          <div class="wrapper right">
            <div class="circleProgress rightcircle"></div>
          </div>
          <div class="wrapper left">
            <div class="circleProgress leftcircle"></div>
          </div>
        </div> -->
      </div>
      <div class="img-box">
        <img id="two" src="https://static.xfanread.com/readingDay2020/quickspot/csdhl2@2x.png" @click="handleClickTwo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      isOver: false, // 是否任务结束
      usetime: '08:36',
      userPoint: [],
      userX: '',
      userY: '',
      diffPoint: [
        {
          pointNo: 1,
          pointX: 274,
          pointY: 138
        },
        {
          pointNo: 2,
          pointX: 925,
          pointY: 324
        },
        {
          pointNo: 3,
          pointX: 313,
          pointY: 435
        }
      ]
    }
  },
  components: {},
  created() { },
  mounted() {
    // this.$nextTick(() => {
    //   this.init()
    // })
  },
  methods: {
    getOffsetTop(obj) {
      var tmp = obj.offsetTop // 图片距外层div上边框的距离
      var val = obj.offsetParent // 如果祖先元素中具有定位元素，此属性返回距离它最近的定位元素。
      //.如果祖先元素中没有定位元素，那么返回最近的table、td、th或者body元素。
      while (val != null) {
        tmp += val.offsetTop
        val = val.offsetParent
      }
      return tmp
    },
    getOffsetLeft(obj) {
      var tmp = obj.offsetLeft // 图片距外层div左边框的距离
      var val = obj.offsetParent
      while (val != null) {
        tmp += val.offsetLeft
        val = val.offsetParent
      }
      return tmp
    },
    handleClickOne(event) {
      // console.log(event, 'event')
      // console.log(
      //   'pageX:',
      //   event.pageX,
      //   'pageY:',
      //   event.pageY,
      //   '鼠标在文档的位置'
      // )
      // console.log(
      //   'document.getElementById(' + 'one' + ').offsetTop',
      //   document.getElementById('one').offsetTop,
      //   'document.getElementById(' + 'one' + ').offsetLeft',
      //   document.getElementById('one').offsetLeft,
      //   '图片距文档的距离'
      // )
      let objTop = this.getOffsetTop(document.getElementById('one')) //图片距外层定位元素的位置
      let objLeft = this.getOffsetLeft(document.getElementById('one')) //图片距外层定位元素的位置
      let mouseX = event.pageX //鼠标距文档的位置
      let mouseY = event.pageY //鼠标y位置
      // console.log(objTop, objLeft, mouseX, mouseY)
      // 点击的位置
      let x1 = mouseX - objLeft
      let y1 = mouseY - objTop
      // console.log(x1, y1, '1点击的位置距图片左上角和左边框的位置')
      this.userX = x1
      this.userY = y1
      const diffPoint = this.diffPoint
      const aa = diffPoint.map(function (item) {
        // console.log(item, 'item')
        // for (const i in item) {
        //   console.log(i, 'iiii')
        // }
        var arr = []
        for (const i in item) {
          // console.log(i, item[i], 'iiiii')
          arr.push(item[i])
        }
        return arr
      })
      console.log(aa, 'aaa')
      const This = this
      aa.map(function (item) {
        console.log(item, 'tttt')
        console.log(item[1], 'x坐标')
        console.log(item[2], 'y坐标')
        if (This.userX === item[1]) {
          // 说明找对了,圆环出现
          This.changeProcess()
        }
        // item.map(function(item) {
        //   // console.log(item, 'oooo')
        //   // console.log(item[1], 'x坐标')
        //   // console.log(item[2], 'y坐标')
        // })
      })
    },
    handleClickTwo(event) {
      let objTop = this.getOffsetTop(document.getElementById('two')) //图片距外层定位元素的位置
      let objLeft = this.getOffsetLeft(document.getElementById('two')) //图片距外层定位元素的位置
      let mouseX = event.pageX //鼠标距文档的位置
      let mouseY = event.pageY //鼠标y位置
      // console.log(objTop, objLeft, mouseX, mouseY)
      // 点击的位置
      let x2 = mouseX - objLeft
      let y2 = mouseY - objTop
      console.log(x2, y2, '2点击的位置距图片左上和左边框的位置')
    },
    /* changeProcess(value) {debugger;
        // value是当前时间，需转换为弧度。总时长x=360deg，当前时长y,当前弧度=360deg*y/x
        if (!value) {
          this.$refs.progressRight.style.transform = `rotate(0deg)`
          this.$refs.progressLeft.style.transform = `rotate(0deg)`
          return
        }
        var num = (value * 360) / this.audioData.audioDuration
        if (num < 180) {
          this.$refs.progressRight.style.transform = `rotate(${num}deg)`
        } else {
          this.$refs.progressRight.style.transform = `rotate(180deg)`
          this.$refs.progressLeft.style.transform = `rotate(${num - 180}deg)`
        }
      },*/
    changeProcess(value) {
      var num = value * 3.6
      if (num < 180) {
        // $('.right').css('transform', 'rotate(' + num + 'deg)')
        this.$refs.progressRight.style.transform = `rotate(${num}deg)`
      } else {
        // $('.right').css('transform', 'rotate(180deg)')
        // $('.left').css('transform', 'rotate(' + (num - 180) + 'deg)')
        this.$refs.progressRight.style.transform = `rotate(180deg)`
        this.$refs.progressLeft.style.transform = `rotate(${num - 180}deg)`
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  font-size: 17px;
  height: 100%;
  background: rgba(247, 238, 226, 1);

  .bkn {
    width: 100%;
    // width: 302px;
    height: 43px;
    // border: 1px solid red;
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 27px;
    position: relative;

    // display: flex;
    // align-items: center;
    // justify-content: center;
    .lb-ico {
      display: inline-block;
      width: 24px;
      height: 21px;
      position: absolute;
      top: 17px;
      left: 15px;

      // margin-top: 15px;
      // margin-left: 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .topic-text {
      display: inline-block;
      width: 302px;
      height: 43px;
      position: absolute;
      top: 14px;
      left: 52.5px;
      // margin-top: 22px;
      // margin-left: 14px;
    }
  }

  .time-box {
    width: 72px;
    height: 14px;
    line-height: 14px;
    // border: 1px solid red;
    margin-top: 41.5px;
    margin-left: 288px;

    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 7.5px;
      background: url('https://static.xfanread.com/readingDay2020/quickspot/zbicon@2x.png');
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  .img-group {
    margin-top: 12px;
  }

  .img-box {
    width: 345px;
    height: 215px;
    border-radius: 1px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .progress-wrap {
      background: #ff0000; //注意这是表示当前进度的颜色
      border-radius: 50%;
      width: 56px;
      height: 56px;
      position: absolute;
      top: -3px;
      left: -3px;
    }

    .pie-right,
    .pie-left {
      //这俩元素主要是为了分别生成两个半圆的，所以起作用的地方在于clip裁掉另一半
      position: absolute;
      top: -1px;
      left: -1px;
      height: 58px;
      width: 58px;
      border-radius: 50%;
    }

    .right,
    .left {
      position: absolute;
      top: 0;
      left: 0;
      height: 58px;
      width: 58px;
      border-radius: 50%;
      background: blue; //注意这个才不是当前进度的颜色
    }

    .pie-right,
    .right {
      //裁掉左边一半
      clip: rect(0, auto, auto, 29px);
    }

    .pie-left,
    .left {
      //裁掉右边一半
      clip: rect(0, 29px, auto, 0);
    }

    .mask {
      //我是遮罩 mask不用改 好欣慰
      position: absolute;
      top: 3px;
      left: 3px;
      height: 50px;
      width: 50px;
      background: #fff;
      border-radius: 50%;
      text-align: center;
    }

    // .circle {
    //   //这个元素可以提供进度条的颜色
    //   position: absolute;
    //   height: 50px;
    //   width: 50px;
    //   border-radius: 50%;
    //   background: red; //注意这是表示当前进度的颜色
    // }
    // .pie-right,
    // .pie-left {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   height: 50px;
    //   width: 50px;
    //   border-radius: 50%;
    //   background: red; //注意这是表示当前进度的颜色
    // }
    // .right,
    // .left {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   height: 50px;
    //   width: 50px;
    //   border-radius: 50%;
    //   background: blue; //注意这个才不是当前进度的颜色
    // }
    // .pie-right,
    // .right {
    //   clip: rect(0, auto, auto, 25px);
    // }
    // .right {
    //   transform: rotate(180deg);
    //   // animation: circleProgressLoad_right 5s linear infinite;
    // }
    // .left {
    //   transform: rotate(30deg);
    //   // animation: circleProgressLoad_left 5s linear infinite;
    // }
    // .pie-left,
    // .left {
    //   //裁掉右边一半
    //   clip: rect(0, 25px, auto, 0);
    // }
    // .mask {
    //   //我是遮罩
    //   position: absolute;
    //   // top: 25px;
    //   // left: 25px;
    //   // top: 0px;
    //   // left: -3px;
    //   top: 4px;
    //   left: 4px;
    //   height: 42px;
    //   width: 42px;
    //   background: #fff;
    //   border-radius: 50%;
    //   text-align: center;
    // }

    // .circleProgress_wrapper {
    //   width: 200px;
    //   height: 200px;
    //   margin: 50px auto;
    //   position: relative;
    //   border: 1px solid #ddd;
    // }

    // .wrapper {
    //   width: 100px;
    //   height: 200px;
    //   position: absolute;
    //   top: 0;
    //   overflow: hidden;
    // }
    // .right {
    //   right: 0;
    // }
    // .left {
    //   left: 0;
    // }
    // .circleProgress {
    //   width: 160px;
    //   height: 160px;
    //   border: 20px solid rgb(232, 232, 12);
    //   border-radius: 50%;
    //   position: absolute;
    //   top: 0;
    //   -webkit-transform: rotate(45deg);
    // }
    // .rightcircle {
    //   border-top: 20px solid green;
    //   border-right: 20px solid green;
    //   right: 0;
    //   -webkit-animation: circleProgressLoad_right 5s linear infinite;
    // }
    // .leftcircle {
    //   border-bottom: 20px solid green;
    //   border-left: 20px solid green;
    //   left: 0;
    //   -webkit-animation: circleProgressLoad_left 5s linear infinite;
    // }
    // @keyframes circleProgressLoad_right {
    //   0% {
    //     border-top: 20px solid #ed1a1a;
    //     border-right: 20px solid #ed1a1a;
    //     -webkit-transform: rotate(45deg);
    //   }
    //   50% {
    //     border-top: 20px solid rgb(232, 232, 12);
    //     border-right: 20px solid rgb(232, 232, 12);
    //     border-left: 20px solid rgb(81, 197, 81);
    //     border-bottom: 20px solid rgb(81, 197, 81);
    //     -webkit-transform: rotate(225deg);
    //   }
    //   100% {
    //     border-left: 20px solid green;
    //     border-bottom: 20px solid green;
    //     -webkit-transform: rotate(225deg);
    //   }
    // }
    // @keyframes circleProgressLoad_left {
    //   0% {
    //     border-bottom: 20px solid #ed1a1a;
    //     border-left: 20px solid #ed1a1a;
    //     -webkit-transform: rotate(45deg);
    //   }
    //   50% {
    //     border-bottom: 20px solid rgb(232, 232, 12);
    //     border-left: 20px solid rgb(232, 232, 12);
    //     border-top: 20px solid rgb(81, 197, 81);
    //     border-right: 20px solid rgb(81, 197, 81);
    //     -webkit-transform: rotate(45deg);
    //   }
    //   100% {
    //     border-top: 20px solid green;
    //     border-right: 20px solid green;
    //     border-bottom: 20px solid green;
    //     border-left: 20px solid green;
    //     -webkit-transform: rotate(225deg);
    //   }
    // }
  }

  .mb-24 {
    margin-bottom: 24px;
  }
}</style>



// WEBPACK FOOTER //
// src/pages/Enterprise.vue